"use strict";
// ENUMS

// Fill in the Enum and as Name the Translation Property.
var _ENUM = {
	"LEARNMODESTATE" : {
		"0" : { Name : "LEARNMODE_Finished" },
		"1" : { Name : "LEARNMODE_Error"},
		"2" : { Name : "LEARNMODE_Running"},
		"3" : { Name : "LEARNMODE_Stopping"}
	},
	"PROTOCOLTYPE" : {
		"-1" : { Name : 'PROTOCOLTYPE_All'},
		"0" : { Name : "PROTOCOLTYPE_LocalSystem" },
		"1" : { Name : "PROTOCOLTYPE_ModbusTCP"},
		"2" : { Name : "PROTOCOLTYPE_ModbusRTU"},
		"3" : { Name : "PROTOCOLTYPE_EnOceanESP3"},
		"4" : { Name : "PROTOCOLTYPE_KNX"},
		//"5" : { Name : "PROTOCOLTYPE_Demo"},
		"6": { Name: "PROTOCOLTYPE_MoehlenhoffXML" },
		"7": { Name: "PROTOCOLTYPE_DemoProtocol" }
	}
}


/*
       SYSTEM = 0,
        UNKNOWN = 1,

        [Description("x-change dynamic")]
        XChangeDynamic = 2,

        [Description("x-change compact")]
        XChangeCompact = 3,

        XNetBase = 4,

        XNetHeatArea = 5,
        XNetCtrl = 6,
        /// <summary>
        /// Switch
        /// </summary>
        EnOceanF60201 = 8, //Switch
        /// <summary>
        /// Hora
        /// </summary>
        EnoceanA52004 = 9, //Hora
        /// <summary>
        /// Kieback
        /// </summary>
        EnoceanA52001 = 10, //Kieback
        /// <summary>
        /// Contact
        /// </summary>
        EnoceanD50001 = 11, //Contact
        /// <summary>
        /// RoomOperatingPanel
        /// </summary>
        EnoceanA51006 = 12,//RoomOperatingPanel

        /// <summary>
        /// Temperature Sensor
        /// </summary>
        EnoceanA50205 = 13,
        /// <summary>
        /// Zähler
        /// </summary>
        EnoceanA51201 = 14,
        /// <summary>

        /// Bidirektionaler Aktor
        /// </summary>
        EnoceanF60201VirtualSwitch = 15, //VirtualSwitch

        /// <summary>
        /// Peha Aktor
        /// </summary>
        EnoceanD201XX = 16,

        /// <summary>
        /// Raumbediengerät
        /// </summary>
        EnoceanA51022 = 18,

        [Description("x-well")]
        XWell = 19,

        [Description("x-well N170")]
        XWellN170 = 20,

        /// <summary>
        /// Thermokon Licht-Steuerung STC-DO
        /// </summary>
        EnoceanA53002 = 21,

        /// <summary>
        /// Raumbediengerät
        /// </summary>
        EnoceanA51005 = 22,

        /// <summary>
        /// DemoDevice
        /// </summary>
        DemoDevice = 23,

        /// <summary>
        /// Raumbediengerät Thermokon
        /// </summary>
        EnoceanD2FEFE = 24,

        ///// <summary>
        ///// Permundo Aktor
        ///// </summary>
        //EnoceanD20109 = 17,

        All = 0xffff

*/

angular.module('app.configuration.enum', []).//

constant('_ENUM', _ENUM);